import styled from 'styled-components';

const FlexItem = styled.div`
  flex: ${props => (props.expands ? '0 1 auto' : '0 0 auto')}
  align-self: ${props => (props.alignSelf ? props.alignSelf : 'center')};
  ${props => (props.width ? 'width: ' + props.width + ';' : '')}
`;

export default FlexItem;
